import { createAsyncThunk } from '@reduxjs/toolkit';

import { MasooliatMadaniApiPaths } from 'Feature/Asansour/Common/Constant/MasooliatMadaniApiPaths';
import {
  MasooliatMadaniHttpGetService,
  MasooliatMadaniHttpPostService,
} from 'Feature/Asansour/Common/Services/MasooliatMadaniHttpService';
import { BasicInfoApiPaths } from 'Feature/Common/Common/Constant/ApiPaths/BasicInfoApiPaths';
import { BasicInfoHttpGetService } from 'Feature/Common/Common/Services/BasicInfoHttpService';

export const bimehNamehMasooliatMadaniOmumiSaderShodeh = createAsyncThunk(
  'ParvandehKhesarat/checkBimehNamehMasooliatMadaniOmumiStatus',
  async (query: any) => {
    return await MasooliatMadaniHttpGetService({
      url: `${MasooliatMadaniApiPaths.BimehNamehHayeMadani.BimehNamehMasooliatMadaniOmumiSaderShodeh}`,

      params: query,
    });
  }
);

export const addBimehNamehMasooliatMadaniToOrder = createAsyncThunk(
  'MasooliatMadaniOmumi/addBimehNamehMasooliatMadaniToOrder',
  async (command: any) => {
    return await MasooliatMadaniHttpPostService({
      url: `${MasooliatMadaniApiPaths.BimehNamehHayeMadani.AddToOrder}`,
      body: command,
    });
  }
);

export const createShenasehPardakht = createAsyncThunk(
  'MasooliatMadaniOmumi/createShenasehPardakht',
  async (command: any) => {
    return await MasooliatMadaniHttpPostService({
      url: `${MasooliatMadaniApiPaths.BimehNamehHayeMadani.CreateShenasehPardakht}`,
      body: command,
    });
  }
);

export const estelamMasooliatMadaniOmumi = createAsyncThunk('MasooliatMadaniOmumi/Estelam', async (command: any) => {
  return await MasooliatMadaniHttpPostService({
    url: `${MasooliatMadaniApiPaths.BimehNamehHayeMadani.Estelam}`,
    body: command,
  });
});

export const getActivePoosheshHayeMasooliatMadani = createAsyncThunk(
  'PoosheshMasooliatMadani/GetActivePoosheshHayeMasooliatMadani',
  async (query: any) => {
    return await MasooliatMadaniHttpGetService({
      url: `${MasooliatMadaniApiPaths.poosheshMasooliatMadani.getActivePoosheshHayeMasooliatMadani}`,
      params: query,
    });
  }
);
export const getActiveTaahodatHazinehPezeshki = createAsyncThunk(
  'TaahodHazinehPezeshki/getActiveTaahodatHazinehPezeshki',
  async () => {
    return await MasooliatMadaniHttpGetService({
      url: `${MasooliatMadaniApiPaths.taahodHazinehPezeshki.getActiveTaahodatHazinehPezeshki}`,
    });
  }
);

export const getLastMarjaeDieh = createAsyncThunk('MarjaeDieh/GetLastMarjaeDieh', async () => {
  return await BasicInfoHttpGetService({
    url: `${BasicInfoApiPaths.MarjaeDieh.GetLastMarjaeDieh}`,
  });
});

export const printBimehNamehMadani = createAsyncThunk('MadaniPrint/printBimehNamehMadani', async (query: any) => {
  return await MasooliatMadaniHttpGetService({
    url: `${MasooliatMadaniApiPaths.BimehNamehHayeMadani.PrintBimehNamehMadani}`,
    params: query,
    responseType: 'blob',
    isFile: true,
  });
});

export const getBimehNamehMadaniDetail = createAsyncThunk(
  'BimehNamehMadani/GetBimehNamehMadaniDetail',
  async (query: any) => {
    return await MasooliatMadaniHttpGetService({
      url: `${MasooliatMadaniApiPaths.BimehNamehHayeMadani.GetBimehMadani}`,
      params: {
        ...query,
      },
    });
  }
);

export const getMozuatFaaliatOmumi = createAsyncThunk('MozuFaaliatOmumi/GetMozuatFaaliatOmumi', async (query: any) => {
  return await MasooliatMadaniHttpGetService({
    url: `${MasooliatMadaniApiPaths.mozuFaaliatOmumi.GetMozuatFaaliatOmumi}`,
    params: query,
  });
});

export const GetAllAnvaeSherkatBimeh = createAsyncThunk('NoeSherkatBimeh/GetAllAnvaeSherkatBimeh', async () => {
  return await BasicInfoHttpGetService({
    url: `${BasicInfoApiPaths.NoeSherkatBimeh.GetAllAnvaeSherkatBimeh}`,
  });
});

export const printBimehNamehMadaniById = createAsyncThunk(
  'BimehNamehMadani/printBimehNamehMadaniById',
  async (query: any) => {
    return await MasooliatMadaniHttpGetService({
      url: `${MasooliatMadaniApiPaths.BimehNamehHayeMadani.PrintBimehNamehMadaniById}`,
      params: query,
      responseType: 'blob',
      isFile: true,
    });
  }
);
